import { InjectionToken } from '@angular/core';
import { LocalCache } from '@nk/caching-lib';
import { GeoCountryEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface MembershipGeoCountryApiService {
  appMembershipGeoCountryPreference$: Observable<GeoCountryEntity[]>;
  geoCountryListByMembershipCache: LocalCache<MembershipGeoCountryApiService, () => Observable<GeoCountryEntity[]>>;
  // TODO: add more when needed
}
export const MEMBERSHIP_GEO_COUNTRY_API_SERVICE_TOKEN = new InjectionToken<MembershipGeoCountryApiService>(
  'MembershipGeoCountryApiService',
);
